/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */
import axios from 'axios';

export class VdvService {
  static playVDV(url) {
    const playURL = url + '#vdv';
    window.location.href = playURL;
  }

  static async isVDVEnableSRP() {
    return window.isVdvPanelEnabled && !window.disableVdvOnSrp;
  }
}

export function isVDVEnabledOnVdp() {
  return window.isVdvPanelEnabled && !window.disableVdvOnVdp;
}

export function isVDVEnabledOnSpecialOffers() {
  return window.isVdvPanelEnabled && !window.disableVdvOnSpecialOffers;
}
export function isVDVEnabledOnDynamicBanners() {
  return window.isVdvPanelEnabled && !window.disableVdvOnDynamicBanners;
}

export async function getVdvCtaSettings(accountId = '', campaignId = '') {
  // Use window values if parameters are empty
  accountId = accountId || window.accountId;
  campaignId = campaignId || window.campaignId;

  try {
    const url = `${window.ApiBaseUrl}/VdvCtaSettings/${accountId}/${campaignId}`;
    const response = await axios.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching VdvCtaSettings:', error);
  }
}

export function hasDynamicBannerPlayButton(bannerData) {
  let isPlayButtonEnabled = false;

  if (!isVDVEnabledOnDynamicBanners() || !bannerData) {
    return isPlayButtonEnabled;
  }

  const bannersPaymentHomenetVehicle = bannerData?.offer || bannerData.bannersPaymentHomenetVehicle;

  if (!bannersPaymentHomenetVehicle?.vdvEligible) {
    return isPlayButtonEnabled;
  }

  if (!bannersPaymentHomenetVehicle?.vdvEligible) {
    return isPlayButtonEnabled;
  }

  if (bannerData?.bannersPaymentHomenetVehicle) {
    const { paymentTypeToDisplay, yourPrice, payment } = bannersPaymentHomenetVehicle;

    const isCashPayment = paymentTypeToDisplay?.toLowerCase() === 'cash';
    const hasYourPrice = !!yourPrice;
    const hasPayment = !!payment;
    const isNonCashPayment = !isCashPayment;

    if ((isCashPayment && hasYourPrice) || (hasPayment && isNonCashPayment)) {
      isPlayButtonEnabled = true;
    }
  } else {
    isPlayButtonEnabled = true;
  }

  return isPlayButtonEnabled;
}
